import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { type FormValues, useFormStore } from "@/widgets/classic-form/form";
import { FieldComposer, FieldComposerFieldType } from "@/features/form-fields";
import type { FieldPath } from "@/shared/forms";
import styles from "./PossibleLocation.module.scss";

const LIVED_FIELD_PATH = "events.Self.instances.0" as const satisfies FieldPath<FormValues>;
const LIVED_LOCATION_EXACTNESS_PATH =
    "events.Self.instances.0.locationExactness" as const satisfies FieldPath<FormValues>;

export const PossibleLocation = () => {
    const { t } = useTranslation();
    const givenName = useFormStore(({ values }) => values.name.givenName);

    return (
        <FieldComposer
            fieldPath={LIVED_FIELD_PATH}
            exactnessFieldPath={LIVED_LOCATION_EXACTNESS_PATH}
            fieldConfig={{
                fieldType: FieldComposerFieldType.Place,
                label: (
                    <div>
                        <p>
                            <strong>{t("searchAssist.anyPlaceWherePersonLived", { name: givenName })}</strong>
                            <span className={styles.optional}>{t("searchAssist.optional")}</span>
                        </p>
                        <span className={styles.helperText}>{t("searchAssist.locationHelperText")}</span>
                    </div>
                ),
                required: false,
            }}
        >
            <FieldComposer.Label />

            <span className={classNames("icon iconMap", styles.assistIcon)} />
            <FieldComposer.FieldConnector>
                {({ formField }, id) => (
                    <FieldComposer.Inputs.Place
                        {...formField}
                        id={id}
                        placeholder={t("searchAssist.locationPlaceholder")}
                    />
                )}
            </FieldComposer.FieldConnector>
        </FieldComposer>
    );
};
